import * as React from 'react';
import { Meal } from '../../../../../../CheckoutAdditionalService/components';
import { groupGdsSelectedServices } from '../utils';
import { useTranslation } from 'react-i18next';
import { Direction, Meal as MealIcon } from '../../../../../../Icons/Icons';
import cn from 'classnames';
import { useTheme } from '../../../../../../theme';
const AggregatedMeal = ({ segmentId, service, hideCard }) => {
    const { t } = useTranslation('ServiceAggregation');
    const theme = useTheme('Checkout').ServicesAggregationPage;
    const selectedServices = groupGdsSelectedServices(service);
    return (React.createElement(Meal, { minPrice: service.minPrice, totalPrice: service.totalPrice, aggregationMode: true, segmentId: segmentId, isSelected: !!service.selectedServices.length, aggregationIcons: [MealIcon, Direction], className: cn({
            [theme.hideServiceCard]: hideCard
        }) }, selectedServices.map(service => {
        return (React.createElement("div", { key: service.service.rfics },
            service.service.name,
            " - ",
            service.count,
            " ",
            t('dish', { count: service.count })));
    })));
};
export default AggregatedMeal;
